/**
 * BusinessCRMFields — slim shell that composes the visual parts with the hook.
 * After refactor: ~75 lines (was 281). Complexity: ~8 (was 46).
 */
import React, { useState } from "react";
import { Tag, Clock, StickyNote } from "lucide-react";
import useBusinessCRM from "../hooks/useBusinessCRM";
import {
  Section, TagsSection, FollowUpSection, NotesTimeline,
  CustomFieldsSection, AddFieldButton,
} from "./BusinessCRMFields.parts";

export default function BusinessCRMFields({ business, onUpdate }) {
  const crm = useBusinessCRM(business, onUpdate);
  const [tagInput, setTagInput] = useState("");
  const [noteInput, setNoteInput] = useState("");
  const [addingField, setAddingField] = useState(false);
  const [newField, setNewField] = useState({ label: "", field_id: "", type: "text" });

  const handleAddTag = async () => {
    if (await crm.addTag(tagInput)) setTagInput("");
  };
  const handleAddNote = async () => {
    if (await crm.addNote(noteInput)) setNoteInput("");
  };
  const handleCreateField = async () => {
    if (await crm.createFieldSchema(newField)) {
      setNewField({ label: "", field_id: "", type: "text" });
      setAddingField(false);
    }
  };

  return (
    <div className="space-y-3" data-testid="business-crm-fields">
      <Section title="Etiquetas" icon={<Tag size={13} />}>
        <TagsSection
          tags={crm.tags}
          tagInput={tagInput}
          setTagInput={setTagInput}
          onAdd={handleAddTag}
          onRemove={crm.removeTag}
        />
      </Section>

      <Section title="Próximo seguimiento" icon={<Clock size={13} />}>
        <FollowUpSection
          date={business.follow_up_date}
          notes={business.follow_up_notes}
          onDateChange={(v) => crm.saveFollowup("follow_up_date", v)}
          onNotesChange={(v) => crm.saveFollowup("follow_up_notes", v)}
        />
      </Section>

      <Section title="Notas internas" icon={<StickyNote size={13} />}>
        <NotesTimeline
          notes={crm.notes}
          noteInput={noteInput}
          setNoteInput={setNoteInput}
          onAdd={handleAddNote}
          onRemove={crm.removeNote}
        />
      </Section>

      <Section
        title="Campos personalizados"
        icon={<Tag size={13} />}
        action={<AddFieldButton onClick={() => setAddingField((v) => !v)} />}
      >
        <CustomFieldsSection
          schema={crm.schema}
          loading={crm.loading}
          business={business}
          addingField={addingField}
          setAddingField={setAddingField}
          newField={newField}
          setNewField={setNewField}
          onCreateSchema={handleCreateField}
          onDeleteSchema={crm.deleteFieldSchema}
          onSaveValue={crm.saveCustomField}
          onClearValue={crm.clearCustomField}
        />
      </Section>
    </div>
  );
}
